import * as actionTypes from './types/errorDescriptionTypes';

export function errorDescriptionRetrieved(errorDescription) {
    return {
        type: actionTypes.ERROR_DESCRIPTION_FETCHED,
        error: { ...errorDescription },
    };
}
